export default __webpack_public_path__ + "static/media/P_Pipoca.0279f84b.mp3";